import { inspectionClient } from '../config/api';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

export interface InspectionIssueTypeParam {
  id: string;
  name: string;
  description?: string;
  sourceRole: string;
  targetRole: string;
  isActive: boolean;
}

export interface CreateInspectionIssueTypeParamRequest {
  name: string;
  description?: string;
  sourceRole: string;
  targetRole: string;
}

export interface UpdateInspectionIssueTypeParamRequest {
  name: string;
  description?: string;
  sourceRole: string;
  targetRole: string;
  isActive: boolean;
}

class InspectionIssueTypeParamService {
  private readonly basePath = '/api/inspection-issue-type-params';

  getAll = async (): Promise<InspectionIssueTypeParam[]> => {
    try {
      const response = await inspectionClient.get<InspectionIssueTypeParam[]>(this.basePath);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao buscar tipos de pendência');
    }
  };

  getActive = async (): Promise<InspectionIssueTypeParam[]> => {
    try {
      const response = await inspectionClient.get<InspectionIssueTypeParam[]>(`${this.basePath}/active`);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao buscar tipos de pendência ativos');
    }
  };

  getByRole = async (sourceRole: string): Promise<InspectionIssueTypeParam[]> => {
    try {
      const response = await inspectionClient.get<InspectionIssueTypeParam[]>(
        `${this.basePath}/by-role/${sourceRole}`
      );
      return Array.isArray(response.data) ? response.data : [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao buscar tipos de pendência por perfil');
    }
  };

  create = async (data: CreateInspectionIssueTypeParamRequest): Promise<string> => {
    try {
      const response = await inspectionClient.post<string>(this.basePath, data);
      return typeof response.data === 'string' ? response.data : '';
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao criar tipo de pendência');
    }
  };

  update = async (id: string, data: UpdateInspectionIssueTypeParamRequest): Promise<void> => {
    try {
      await inspectionClient.put(`${this.basePath}/${id}`, data);
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao atualizar tipo de pendência');
    }
  };

  delete = async (id: string): Promise<void> => {
    try {
      await inspectionClient.delete(`${this.basePath}/${id}`);
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao excluir tipo de pendência');
    }
  };
}

export const inspectionIssueTypeParamService = new InspectionIssueTypeParamService();
